export default "__VITE_ASSET__DtrtWy2h__"